import React, { useContext, useState, useEffect, useMemo } from 'react';
import { Button, InlineEditColumnProps, notification, Table, Widget, } from '@digital/ui';
import { Collapse, Icon, Input } from 'antd';
import { CrfRequisitadoComOrdemCompra, CrfRequisitadoRc, CrfRequisitadoSemOrdemCompra } from '@app/api/crf/crfprojeto';


interface DetalheProjetoFechamentoRequisitadoProps {
  requisitadoRc: CrfRequisitadoRc[];
  projetoId: string;
  fechamentoId: string;
  handleTabelaSemOrdemRequistado(semOrdem: CrfRequisitadoSemOrdemCompra[], displayWidget: string): void;
  handleTabelaComOrdemRequistado(ComOrdem: CrfRequisitadoComOrdemCompra[], displayWidget: string): void;
}

const DetalheProjetoFechamentoRequisitado = (props: DetalheProjetoFechamentoRequisitadoProps) => {
  const { requisitadoRc, projetoId, fechamentoId, handleTabelaSemOrdemRequistado, handleTabelaComOrdemRequistado } = props;
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [ordemInvestimentoId, setOrdemInvestimentoId] = useState<string>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<CrfRequisitadoRc>();
  const [valorTotal, setValorTotal] = useState<string>();



  useEffect(() => {
    const getData = () => {
      if (requisitadoRc.length > 0) {
        var requisitado = requisitadoRc[requisitadoRc.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.valorTotalFormatado);
        }
      }
    };
    getData();
  }, [requisitadoRc]);


  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '2%',
      },
      {
        title: 'Código do pacote',
        dataIndex: 'codigoPacote',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '67%',
      },
      {
        title: 'Status Requisitado',
        dataIndex: 'rcStatus',
        width: '15%',
      },
      {
        title: 'Valor Requisitado',
        dataIndex: 'valorTotalCurrency',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal}`,
            dataIndex: 'requisicaoCompraValorTotalFormatado',
            width: '1%',
          },
        ],
      },
    ] as InlineEditColumnProps<CrfRequisitadoRc>[];
  };

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      var obj = selectedRows[0];
      if (selectedRows) {
        setOrdemInvestimentoId(obj.crfContaContabilCcId);
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any }) => (
      {
        disabled: record.name === 'Disabled User',
        name: record.name,
      }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio',
  };

  const hasGetAllRequisitoSemOrdemCompraProjeto = (id: string) => {
    let resultRequisitadoSemOrdemCompra: CrfRequisitadoSemOrdemCompra[] = [];

    if (requisitadoRc) {
      requisitadoRc.map((rq) => {
        if (rq.crfContaContabilCcId === id) {
          resultRequisitadoSemOrdemCompra = rq.requisitadoSemOndemDeCompra;
        }
      });
    }
    return resultRequisitadoSemOrdemCompra;
  }

  const hasGetAllRequisitoComOrdemCompraProjeto = (id: string) => {
    let resultRequisitadoSemOrdemCompra: CrfRequisitadoComOrdemCompra[] = [];
    if (requisitadoRc) {
      requisitadoRc.map((rq) => {
        if (rq.crfContaContabilCcId === id) {
          resultRequisitadoSemOrdemCompra = rq.requisitadoComOrdemDeCompra;
        }
      });
    }
    return resultRequisitadoSemOrdemCompra;
  }

  const verRequisitado = () => {
    if (ordemInvestimentoId) {

      const getRequisitadoCompra = async (id: string) => {
        const result = await hasGetAllRequisitoSemOrdemCompraProjeto(id);
        if (result) {
          handleTabelaSemOrdemRequistado(result, "{ display: 'block' }");
        }
      };

      const getRequisitadoComOrdemCompra = async (id: string) => {
        const result = await hasGetAllRequisitoComOrdemCompraProjeto(id);
        if (result) {
          handleTabelaComOrdemRequistado(result, "{ display: 'block' }");
        }
      };

      getRequisitadoCompra(ordemInvestimentoId);
      getRequisitadoComOrdemCompra(ordemInvestimentoId);

    } else {
      notification.error('Você deve selecionar um item');
    }
  }

  return (
    <>
      <Widget actions={[
        <Button
          type="primary"
          title="VER REQUISITADO"
          icon="data-database"
          onClick={() => {
            verRequisitado();
          }}
        />
      ]}>

        <Table
          rowKey="index"
          columns={customColumns()}
          dataSource={requisitadoRc}
          rowSelection={{
            ...rowSelection,
          }}
        />
      </Widget>

    </>
  );
};

export default DetalheProjetoFechamentoRequisitado;
